'use strict';
import isSerialized from '../utils/isSerialized.js';

/**
 * @description Axios response transformer; called before interceptors and catches response data, headers
 */

function defaultResponseTransformer (data) { // eslint-disable-line no-unused-vars
  let deserializedData = data;
  
  if (isSerialized(data)) { 
    deserializedData = JSON.parse(data);
  }
  
  /* Comment below to toggle dev-logging */
  const printf = 'color: #4CAF50; font-weight: bold';
  console.log('%c RESPONSE: DATA ===> ', printf, { data: deserializedData });

  return deserializedData;
}

export default defaultResponseTransformer;